import React, { useEffect, useState } from "react";
import styles from "./styles/Footer.module.css";
import MediaLink from "./MediaLink";
import { useTranslation } from "react-i18next";
/**
 * Footer card container
 */

const MediaCard = ({ cardInfo, isMessageAvailable }) => {
    const { t } = useTranslation();

    return (
        <div className={`${styles.media_card_container} v-flex-container`}>
            <div
                className={`${styles.media_card_header_container} v-flex-container`}
            >
                <h3
                    className={`${styles.media_card_header} ${
                        isMessageAvailable ? styles.no_message : ""
                    }`}
                >
                    {t(cardInfo?.header)}
                </h3>

                {isMessageAvailable ? (
                    <h4 className={`${styles.media_card_message}`}>
                        {t(cardInfo?.message)}
                    </h4>
                ) : (
                    <></>
                )}
            </div>

            <ul className={`${styles.media_card_links_container}`}>
                {cardInfo?.links
                    .filter(
                        (linkInfo) => linkInfo?.enable,
                        // &&
                        //     (linkInfo?.icon !== "no logo" ||
                        //         t(linkInfo?.body_l1)),
                    )
                    .map((linkInfo) => (
                        <li
                            className={`${styles.media_card_link_item}`}
                            key={`${cardInfo?.id}${linkInfo?.id}`}
                        >
                            <MediaLink linkInfo={linkInfo} />
                        </li>
                    ))}
            </ul>
        </div>
    );
};

export default MediaCard;
